import { gql } from "@apollo/client";

export const ADJUST_CRIMCOINS = gql`
  mutation AdjustCrimcoins($input: AdjustCrimcoinsInput!) {
    adjustCrimcoins(input: $input) {
      balance
      entry {
        id
        amount
        description
        type
        createdAt
      }
    }
  }
`;
